module.exports = __webpack_public_path__ + "img/yzm.721fe966.png";